import { create } from 'zustand';
const initialState = {
    id: null,
    open: false,
    styles: null,
    options: [],
    onChange: null,
    searchable: true,
    className: null,
    onlyKey: false
};
const useSelectMenuStore = create((set)=>({
        ...initialState,
        setData: (data)=>set(()=>{
                // variables
                let styles = null;
                if (data === null || data === void 0 ? void 0 : data.id) {
                    const parent = document.getElementById("".concat(data.id, "_holder"));
                    if (parent) {
                        let { height, width, left, top } = parent.getBoundingClientRect();
                        if (data.useOffset) {
                            top = parent.offsetTop;
                            left = parent.offsetLeft;
                        }
                        styles = {
                            height,
                            width,
                            left,
                            top: top + height + 8
                        };
                    } else return initialState;
                }
                return data ? {
                    ...data,
                    styles
                } : initialState;
            })
    }));
export default useSelectMenuStore;
